<template>
  <div
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    style="min-width: 200px;"
  >
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
    <div class="input-group">
      <v-textarea
        v-model="value"
        v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
        :rules="isRequired ? [v => !!v || 'Required'] : []"
        :disabled="readonly"
        :aria-label="fieldType.text || question.text"
        browser-autocomplete="off"
        @blur="save"
        @focus="focus"
      >
        <v-icon
          v-if="answer.status"
          slot="prepend"
        >
          {{ statusIconClass }}
        </v-icon>
      </v-textarea>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'

export default {
  name: 'NameAnswer',
  mixins: [answerMixin],
  props: [ 'readonly' ],
  components: { TryAgain },
  data () {
    return {
      value: '',
      savedValue: '',
      failed: false,
      menu: false
    }
  },
  beforeMount () {
    this.value = this.answer.text || ''
  }
}
</script>

<style>
.follow-up textarea {
  background-color: #ffffcc;
}
</style>
